import { render } from "./rolForm.vue?vue&type=template&id=521a56ee"
import script from "./rolForm.vue?vue&type=script&lang=js"
export * from "./rolForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__